import { Injectable, EventEmitter, Type } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MnRightnavService {

    // private _component$ = new BehaviorSubject<Type<any>>(null);
    // private _state$ = new BehaviorSubject<MnRightnavState>(MnRightnavState.Main);
    // private _title$ = new BehaviorSubject<string>('');

    public back = new EventEmitter();

    // public get component$(): Observable<Type<any>> {
    //     return this._component$.asObservable();
    // }

    // public get component(): Type<any> {
    //     return this._component$.value;
    // }

    // public set component(val: Type<any>) {
    //     this._component$.next(val);
    // }

    // public get state$(): Observable<MnRightnavState> {
    //     return this._state$.asObservable();
    // }

    // public get state(): MnRightnavState {
    //     return this._state$.value;
    // }

    // public set state(val: MnRightnavState) {
    //     this._state$.next(val);
    // }

    // public get title$(): Observable<string> {
    //     return this._title$.asObservable();
    // }

    // public get title(): string {
    //     return this._title$.value;
    // }

    // public set title(val: string) {
    //     this._title$.next(val);
    // }

}
